import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';
import { getProcessEnvGlobalConfig } from '@shared/config/global';

export const firstProductionSoquestCampaign: Story = {
  id: 'first-production-soquest-campaign',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'First Production Soquest Campaign',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    disabled: getProcessEnvGlobalConfig('isDev'),
    config: {
      key: 'd40c0011b4cac29756ea6197e85c90569fc8',
      scode: 'MagicSquare',
      ccode: 'luFjAuXas6',
      // leaderboardId: '6502c51338237be7229d00bd',
    },
  },
};
